import { ActivityMetaType, type ActivityMeta } from '@/models/Activity';

export const watchActivityMetaMap: Record<number, ActivityMeta> = {
  40001: {
    name: 'Fast Forward',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40002: {
    name: 'Storyboard',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40003: {
    name: 'Facetime',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40004: {
    name: 'Showtime',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40005: {
    name: 'Webcrap',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40007: {
    name: 'Masterclass',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40009: {
    name: `What's Wrong`,
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40010: {
    name: 'Picture This',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40011: {
    name: 'Video',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40012: {
    name: 'Video Call',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40013: {
    name: 'Fact Show',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40014: {
    name: 'Moments',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40015: {
    name: 'Live session',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40016: {
    name: 'Good to Know',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40017: {
    name: 'Explained',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40019: {
    name: 'Video Call',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40041: {
    name: 'More Words',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40042: {
    name: 'Key Moments',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
  40047: {
    name: 'Instructions',
    type: ActivityMetaType.watch,
    icon: 'circle-info',
  },
  40057: {
    name: 'Task Steps',
    type: ActivityMetaType.watch,
    icon: 'camera-movie',
  },
};
